import { IconType, IconProps } from './Icon.types';

const iconPaths: Record<IconType, string> = {
  sun: 'M12 2v2m0 16v2m10-10h-2M4 12H2m15.364-6.364l-1.414 1.414M6.05 17.95l-1.414 1.414m12.728 0l-1.414-1.414M6.05 6.05L4.636 4.636M16 12a4 4 0 11-8 0 4 4 0 018 0z',
  moon: 'M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z',
  menu: 'M3 12h18M3 6h18M3 18h18',
  close: 'M6 18L18 6M6 6l12 12',
  layers: 'M12 2l8 4-8 4-8-4 8-4zm0 6l8 4-8 4-8-4 8-4zm0 6l8 4-8 4-8-4 8-4z',
  plus: 'M12 5v14m7-7H5',
  check: 'M20 6L9 17l-5-5',
  x: 'M18 6L6 18M6 6l12 12',
  'chevron-down': 'M7 10l5 5 5-5',
  'chevron-up': 'M17 14l-5-5-5 5',
  settings:
    'M12 2a10 10 0 00-10 10 10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2zm0 6a4 4 0 100 8 4 4 0 000-8z',
  search: 'M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z',
  location:
    'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0zM12 7a3 3 0 100 6 3 3 0 000-6z',
  navigation: 'M3 11l19-9-9 19-2-8-8-2z',
  map: 'M14.5 2L20 6v14l-5.5-4L9 20l-5.5-4V2l5.5 4L14.5 2z',
  road: 'M2 20h20v2H2v-2zm1.64-6.36c.09-.24.14-.48.14-.72 0-.24-.05-.48-.14-.72L2.5 10l1.14-2.36c.09-.24.14-.48.14-.72 0-.24-.05-.48-.14-.72L2.5 4l1.14-2.36C3.73 1.4 3.78 1.2 3.78 1c0-.55.45-1 1-1h12.44c.55 0 1 .45 1 1 0 .2.05.4.14.64L19.5 4l-1.14 2.36c-.09.24-.14.48-.14.72 0 .24.05.48.14.72L19.5 10l-1.14 2.36c-.09.24-.14.48-.14.72 0 .24.05.48.14.72L19.5 16l-1.14 2.36c-.09.24-.14.4-.14.64 0 .55-.45 1-1 1H4.78c-.55 0-1-.45-1-1 0-.24-.05-.4-.14-.64L2.5 16l1.14-2.36z',
  construction:
    'M12 15l3.53 3.53c.78.78 2.05.78 2.83 0s.78-2.05 0-2.83L15 12l3.53-3.53c.78-.78.78-2.05 0-2.83s-2.05-.78-2.83 0L12 9 8.47 5.47c-.78-.78-2.05-.78-2.83 0s-.78 2.05 0 2.83L9 12l-3.53 3.53c-.78.78-.78 2.05 0 2.83s2.05.78 2.83 0L12 15z',
  'alert-triangle':
    'M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
  barrier: 'M3 12h3l2-9h4l2 9h3m-8.5-3h3m-2-3h2m-3 6h3',
  flag: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1v12z M4 22v-7',
  highway:
    'M2 18h20v2H2v-2zm2-14h16v10H4V4zm2 2v6h12V6H6zm2 1h8v1H8V7zm0 2h8v1H8V9zm0 2h6v1H8v-1zm10-2h2v4h-2V9z',
  'door-open':
    'M5 3h12a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm0 2v14h12V5H5zm8 6a1 1 0 100 2 1 1 0 000-2zm6-2v10l-4-2v-6l4-2z',
  crossroads: 'M12 2v8m0 4v8M2 12h8m4 0h8M8 8l4 4m0 0l4-4M8 16l4-4m0 0l4 4',
  calendar:
    'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z',
  paperclip:
    'm21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.64 16.2a2 2 0 0 1-2.83-2.83l8.49-8.48',
  'list-checks':
    'M9 11l3 3 8-8M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.66 0 3.22.45 4.56 1.24',
  file: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z M14 2v6h6',
  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M7 10l5 5 5-5 M12 15V3',
  'trash-2':
    'M3 6h18 M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6 M8 6V4c0-1 1-2 2-2h4c0-1 1-2 2-2v2 M10 11v6 M14 11v6',
  'grip-vertical':
    'M9 12l2 0 M9 6l2 0 M9 18l2 0 M13 12l2 0 M13 6l2 0 M13 18l2 0',
  'building-bridge':
    'M3 21h18M4 18h16M6 14h12M8 10h8M5 6h14M6 6v8M18 6v8M8 3h8v3H8V3z',
  'traffic-cone':
    'M12 2l-1 1-2 4-2 4-2 4H5l14 0h-2l-2-4-2-4-2-4-1-1zM8 19h8v2H8v-2z',
  camera:
    'M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2v11zM12 17.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM12 15a3 3 0 100-6 3 3 0 000 6z',
  tool: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z',
  'barrier-block':
    'M3 6h18v2L20 8l-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2L8 8l-1 2-1-2L3 8V6zM4 12h16v8H4v-8zM6 14h12v4H6v-4z',
  'map-pin':
    'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0zM12 7a3 3 0 100 6 3 3 0 000-6z',
  clipboard:
    'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2M10 2h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V3a1 1 0 011-1z',
  'road-sign': 'M12 3v18M8 7h8l2 2-2 2H8V7zM8 13h8l2 2-2 2H8v-4z',
  'exclamation-circle': 'M12 2a10 10 0 100 20 10 10 0 000-20zM12 6v6M12 16h.01',
  eye: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 100 6 3 3 0 000-6z',
  globe:
    'M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z',
  logout: 'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9',
  workspace: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9zM9 22V12h6v10',
};

export const Icon = ({
  type,
  size = 24,
  className = '',
  'aria-hidden': ariaHidden = true,
}: IconProps) => {
  const path = iconPaths[type];

  if (!path) {
    console.warn(`Icon type "${type}" not found`);
    return null;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`icon ${className}`}
      aria-hidden={ariaHidden}
    >
      <path d={path} />
    </svg>
  );
};

// Helper components for commonly used icons
export const SunIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="sun" {...props} />
);

export const MoonIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="moon" {...props} />
);

export const MenuIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="menu" {...props} />
);

export const CloseIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="close" {...props} />
);

export const LayersIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="layers" {...props} />
);

export const PlusIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="plus" {...props} />
);

export const CheckIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="check" {...props} />
);

export const SearchIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="search" {...props} />
);

export const GlobeIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="globe" {...props} />
);

export const SettingsIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="settings" {...props} />
);

export const LogoutIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="logout" {...props} />
);

export const WorkspaceIcon = (props: Omit<IconProps, 'type'>) => (
  <Icon type="workspace" {...props} />
);
